// Cookie Banner

const cookieBanner = document.getElementById('cookie-banner');
const cookieAccept = document.getElementById('cookie-accept');
const cookieDeny = document.getElementById('cookie-deny');

function delete_cookie(name, path, domain) {
    if (get_cookie(name)) {
        document.cookie = name + "=" + (
        (path) ? ";path=" + path : ""
    ) + ((domain) ? ";domain=" + domain : "") + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
    }
}

function get_cookie(name) {
    return document.cookie.split(';').some(c => {
        return c.trim().startsWith(name + '=');
    });
}

function runCookieScripts () {

    // Gtag Script 
    window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new
    Date());

    gtag('config', 'G-SBGBKTSK9Y');

    // LinkedIn Pixel Script

    _linkedin_partner_id = "3445386"; 
    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; 
    window._linkedin_data_partner_ids.push(_linkedin_partner_id); 

    (function(l) { if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])}; 
    window.lintrk.q=[]} var s = document.getElementsByTagName("script")[0]; var b = document.createElement("script"); b.type = "text/javascript";b.async = true; b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"; s.parentNode.insertBefore(b, s);})(window.lintrk); 

}

window.addEventListener('DOMContentLoaded', e => { 
    
    // If User Has Already Accepted Cookies, Hide Banner
    if (window.localStorage.getItem('accept_cookies')) {
        cookieBanner.style.display = 'none'
    } else {
        cookieBanner.style.display = 'flex'
        console.log(window.localStorage.getItem('accept_cookies'))
        console.log( cookieBanner.style.display )
    }

    // If "accept_cookies" is true, run gtm script
    if ( !!(window.localStorage.getItem('accept_cookies')*1)) {

        return runCookieScripts()

    }

    // If User Hits "Accept", Remove Cookie Banner and Run GTM Script
    cookieAccept.addEventListener('click', e => {
        window.localStorage.setItem('accept_cookies', 1);
        cookieBanner.style.display = 'none';

        return runCookieScripts()
    })

    // If User Has Hit Deny And/Or "accept_cookies" Is False
    cookieDeny.addEventListener('click', e => {
        window.localStorage.setItem('accept_cookies', 0);
        delete_cookie('_ga', '/', '.psgequity.com')
        delete_cookie('_ga_SBGBKTSK9Y', '/', '.psgequity.com')
        cookieBanner.style.display = 'none'
    })
})
